<template>
  <div>
    <ul class="select-option">
      <li>
        <el-button
          type="primary"
          icon="el-icon-search"
          @click="init"
        >
          查询
        </el-button>
      </li>
    </ul>
    <el-table
      :data="tableData"
      border
      tooltip-effect="dark"
      style="width: 100%"
      max-height="650"
      :row-style="rowStyle"
      :summary-method="getSummaries"
      show-summary
    >
      <el-table-column
        prop="productName"
        label="计划"
        width="200"
        align="center"
      />
      <el-table-column
        prop="fileNotUploadCount"
        label="未交资料"
        width="110"
        align="center"
      />
      <el-table-column
        prop="firstSupplementCount"
        label="初审补资料"
        width="130"
        align="center"
      />

      <el-table-column
        prop="notFirstResultCount"
        label="未初审"
        width="110"
        align="center"
      />
      <el-table-column
        prop="notFeeCount"
        label="待缴费"
        width="110"
        align="center"
      />

      <el-table-column
        prop="surveyingCount"
        label="调查中"
        width="110"
        align="center"
      />
      <el-table-column
        prop="secondNotFinishCount"
        label="调查初审"
        width="120"
        align="center"
      />
      <el-table-column
        prop="secondBackSupplementCount"
        label="调查初审补资料"
        width="130"
        align="center"
      />
      <el-table-column
        prop="reviewNotApproveCount"
        label="待审批"
        width="110"
        align="center"
      />

      <el-table-column
        prop="thirdNotApproveCount"
        label="待三审"
        width="110"
        align="center"
      />
      <el-table-column
        prop="notPublicityCount"
        label="待公示"
        width="110"
        align="center"
      />
      <el-table-column
        prop="canPublicityCount"
        label="可公示"
        width="110"
        align="center"
      />
      <el-table-column
        prop="hasPublicityCount"
        label="已公示"
        width="110"
        align="center"
      />
      <el-table-column
        prop="withdrawalCount"
        label="撤案数"
        width="110"
        align="center"
      />

      <el-table-column
        prop="firstScreenRefusedCount"
        label="初筛不予互助"
        width="110"
        align="center"
      />
      <el-table-column
        prop="firstRefusedCount"
        label="初审不予互助"
        width="110"
        align="center"
      />
      <el-table-column
        prop="secondRefusedCount"
        label="复审不予互助"
        width="110"
        align="center"
      />
      <el-table-column
        prop="rowSum"
        label="合计"
        width="110"
        align="center"
      />
    </el-table>
  </div>
</template>

<script>
export default {
  name: 'RegisterReport',
  data() {
    return {
      loading: false,
      tableData: []
    }
  },

  mounted() {
    this.init()
  },

  methods: {
    /**
     * 初始化页面-报表-库存表
     */
    init() {
      const vm = this
      vm.loading = true

      vm.axios
        .get(
          vm.homePath() + '/report/registerReport?_t=' + new Date().valueOf(),
          {}
        )
        .then((response) => {
          vm.loading = false
          const result = response.data
          if (result.status == '000000') {
            vm.tableData = result.data
          } else {
            vm.tableData = []
            vm.$alert(result.message || '服务器繁忙，请稍后重试', '提示')
          }
        })
        .catch((error) => console.log(error))
    },
    getSummaries(param) {
      const { columns, data } = param
      const sums = []
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计'
          return
        }
        const values = data.map((item) => Number(item[column.property]))
        if (!values.every((value) => isNaN(value))) {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr)
            if (!isNaN(value)) {
              return prev + curr
            } else {
              return prev
            }
          }, 0)
        } else {
          sums[index] = ''
        }
      })

      return sums
    },
    rowStyle({ row, rowIndex }) {
      Object.defineProperty(row, 'rowIndex', {
        value: rowIndex,
        writable: true,
        enumerable: false
      })
    },

    exportExcel() {
      let url = this.homePath() + '/report/month/getReport'
      url +=
        '?startDate=' +
        (this.startDate == null ? '' : this.startDate) +
        '&_t=' +
        new Date().valueOf()
      window.location.href = url
    }
  }
}
</script>

    <style>
.select-title {
  font-size: 14px;
  font-weight: 700;
}

.select-option li {
  float: left;
  margin: 10px;
}

.select-input {
  width: auto;
}

.el-table td,
.el-table th {
  padding: 6px 0px;
}

.el-table th {
  color: #333;
  font-weight: bold;
  text-align: center;
}

.red {
  color: red;
}
</style>
